// extracted by mini-css-extract-plugin
export var accent = "_8r-4";
export var add = "_8r-j";
export var addIcon = "_8r-k";
export var deleteIcon = "_8r-i";
export var disabled = "_8r-9";
export var ellipsis = "_8r-f";
export var error = "_8r-3";
export var form = "_8r-5";
export var hideFocus = "_8r-2";
export var icon = "_8r-7";
export var input = "_8r-e";
export var listItem = "_8r-h";
export var mediumHeight = "_8r-b";
export var noBorder = "_8r-8";
export var noRadius = "_8r-1";
export var shortHeight = "_8r-a";
export var tallHeight = "_8r-c";
export var textInput = "_8r-0";
export var vertical = "_8r-g";
export var veryTallHeight = "_8r-d";
export var widget = "_8r-6";